<template>
  <div class="home">
    <div class="topGo" v-show="!isPad">
      <span class="icon" @click="goHistory"><img class="goHistory" src="../../assets/image/08.png"
             alt=""></span>
      <span class="iconText">学生画像</span>
    </div>
    <a-spin :spinning="loading">
      <div :class="!isPad?'no_pad':'is_pad'">
        <ul class="bookSelect">
          <li :class="current == index?'activeLi':'titleLi'" v-for="(item,index) in bookList" :key="index"
              @click="changeBook(item,index)">{{item.name}}</li>
        </ul>
        <div class="type">
          <ul class="classType">
            <li :class="currentType == index?'activeClass':'classLi'" v-for="(item,index) in classType"
                :key="index" @click="changeType(item,index)">{{item.name}}</li>
          </ul>
          <!-- <div class="search" v-show="studentShow">
                        <a-input-search placeholder="输入学生姓名" style="width: 200px" @search="onSearch" />
                    </div> -->
        </div>
        <div class="clssUl" v-if="classShow">
          <a-checkbox-group :defaultValue="classCheckedList" @change="classChange">
            <a-checkbox :value="item.id" v-for="item in classList" :key="item.id">
              {{item.className}}
            </a-checkbox>
          </a-checkbox-group>
          <!-- <span class="lookAll" v-show="studentShow" @click="lookAllStudent">查看全部 ></span> -->
        </div>
        <a-row class="stuUl" v-if="stuULShow">
          <a-col class="stuLi" :span="3" v-for="(item,index) in studentsCheckedList" :key="index">
            {{item.userName}}</a-col>
        </a-row>
        <div class="classbehaviour" v-show="!showRelDiv">
          <a-checkbox-group :defaultValue="beaviourCheckedList" @change="beaviourChange">
            <a-checkbox :value="item.key" v-for="item in beaviourList" :key="item.key" checked="checked"
                        :disabled=disabled>
              {{item.name}}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </div>

      <div v-show="!showRelDiv">
        <div :class="!isPad?'main':'pad_main'">
          <div class="content">
            <div class="behaviourLoad"> <img class="xingwei" src="../../assets/image/xingwei.png" alt="" />
              行为路径
            </div>
            <ul class="behaviourLoadUl">
              <li :class="becurrent == index?'beactiveLi':'beLi'" v-for="(item,index) in behaviourRoadList"
                  :key="index" @click="changeBehaviour(item,index)">{{item.name}}</li>
            </ul>
            <div id="echarts_bar" :class="!isPad?'echarts_bar':'is_pad_echarts_bar'"> </div>
            <div :class="!isPad?'table':'pad_table'">
              <ul class="tabUl">
                <li class="tabLi"></li>
                <li class="tabLi" v-for="(item,index) in columns" :key=index>{{item.name}}</li>
                <!-- <li class="tabLi" v-for="(i,index) in item.tableData" :key="index">
                            <div>{{i[0].name}}</div>
                        </li> -->
              </ul>
              <ul class="tabUl" v-for="(item,index) in tableData" :key=index>
                <li class="tabLi">{{item.name}} <span style="color:#ddd;margin-left:10px;">|</span> </li>
                <li class="tabLi" v-for="(i,index) in item.tableData" :key="index">
                  <div>{{i.count}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div :class="!isPad?'main2':'pad_main2'">
          <div class="behaviourLoad">
            <img class="xingwei" src="../../assets/image/star.png" alt="" /> 学习类型
            <a-button class="btnExport" type="primary" style="float:right;" @click="exportBehavior"
                      :loading="downBtnLoading"> 导出
            </a-button>
          </div>
          <div id="echarts_star" :class="!isPad?'echarts_star':'is_pad_echarts_star'"></div>
        </div>
      </div>
      <div style="margin-top:30px;" v-show="showRelDiv">
        <div :class="!isPad?'main2':'pad_main2'">
          <div class="behaviourLoad">
            <img class="xingwei" src="../../assets/image/star.png" alt="" /> 交互关系
            <a-button class="btnExport" type="primary" style="float:right;"
                      @click="$event => exportRelation($event)" :loading="downBtnLoading"> 导出
            </a-button>
          </div>
          <div id="echarts_rel" :class="!isPad?'echarts_rel':'is_pad_echarts_rel'"></div>
        </div>
      </div>
    </a-spin>

    <a-modal v-model="studentModal" width="668px" title="查看全部学生" footer="" @cancel="handleCancel"
             @ok="handleOk" destroyOnClose>
      <div class="students">
        <div class="classSelect">
          <a-select :default-value="defautlClassName" style="width:100%;" @change="handleClassChange">
            <a-select-option v-for="(item, index) in studentList" :key="index" :value="item.id">
              {{item.className}}
            </a-select-option>
          </a-select>
          <div class="studentsList">
            <a-checkbox-group style="width:100%;" v-model="checkedList" :options="plainOptions.id"
                              @change="studentsChange">
              <a-row>
                <a-col class="col" :span="6" v-for="item in newStudentList" :key="item.userId">
                  <a-checkbox :value="item">
                    <template>
                      <span class="userName">{{item.userName}}</span>
                    </template>
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
          <div class="bot">
            <div class="checkstu">
              <span class="hasCheck">已选</span>
              <span class="stuDe" v-for="item in  studentsCheckedList"
                    :key="item.userId">{{item.userName}}</span>
            </div>
            <div class="surebtn">
              <a-button class="determine" @click="deterMine">确定</a-button>
              <div class="tt">*最多可同时查看5个学生的数据分析</div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="classModal" width="668px" title="选择班级" footer="" destroyOnClose>
      <a-list bordered :data-source="classList" style="max-height:500px;overflow: auto;">
        <a-list-item style="height:40px;cursor:pointer;" slot="renderItem" slot-scope="item"
                     @click="selectClass(item)">
          {{ item.className }}
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>
<script>
import { decryptDes } from 'utils/crypto.js';
import axios from 'axios';
import format from '../../utils/format.js';

export default {
  name: 'StudentsDraw',
  data() {
    return {
      disabled: true,
      classShow: true,
      stuULShow: false,
      showRelDiv: false,
      bookList: [
        { name: '必修上', key: 0 },
        { name: '必修上1', key: 1 },
        { name: '必修上2', key: 2 },
        { name: '必修上3', key: 3 },
      ],
      current: 0, // 课本年级
      classType: [
        { name: '查看班级表现', key: 1 },
        { name: '查看学生表现', key: 2 },
        { name: '查看学生交互关系', key: 3 },
      ],
      currentType: 0, // 班级分类
      classList: [{ name: '班级1', id: 0 }],
      beaviourList: [
        { name: '班级平均表现', key: 0 },
        { name: '优秀表现', key: 1 },
      ],
      behaviourRoadList: [
        { name: '被动行为', key: 'read' },
        { name: '主动行为', key: 'label' },
        { name: '构建行为', key: 'build' },
        { name: '交互行为', key: 'mutual' },
      ],
      isPad: true,
      becurrent: 0,
      studentShow: false,
      classCheckedList: [], // 班级或学生选择
      beaviourCheckedList: [0, 1], // 班级表现选择
      studentModal: false, // 全部学生列表
      classModal: false, // 全部班级列表
      relClassId: '',
      downBtnLoading: false,
      classSelect: [],
      defautlClassName: [], // 班级默认选择
      studentList: [],
      plainOptions: [], // 选择的学生
      indeterminate: true, // 动画
      checkedList: [],
      studentsCheckedList: [],
      newStudentList: [],
      bookId: '', // 默认
      type: 1,
      classIds: [],
      studentIds: [],
      dataType: 'read', // 行为类型
      columns: [],
      tableData: [],
      userId: '',
      color: ['#FFD300', '#17CE74', '#FF5F4C', '#32C1FF', '#8E83E7', '#FFAB45', '#578EEF'],
      behaviorArray: [],
      access_token: '',
      loading: false,
    };
  },
  mounted() {
    this.logininit();
    // this.init()
    this.bookSimpleList();
    this.getClassList();
    this.getStudentList();
  },
  watch: {
    dataType() {
      this.getChartData();
    },
    studentIds() {},
  },
  methods: {
    goHistory() {
      this.$router.go(-1);
    },
    bookSimpleList() {
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/teacher/statistics/bookSimpleList',
          body: {},
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.bookList = res.resultData;
            _this.bookId = res.resultData[0].id;
          }
        });
    },
    getClassList() {
      // ebook/teacher/statistics/listClass
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/teacher/statistics/listClass',
          body: {
            userId: _this.userId,
          },
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.classList = res.resultData;
            _this.classCheckedList.push(res.resultData[0].id);
            _this.classIds = _this.classCheckedList;
            _this.defautlClassName.push(res.resultData[0].className);

            _this.getChartData();
          }
        });
    },
    // ebook/teacher/statistics/listClassStu
    getStudentList() {
      const _this = this;
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics/listClassStu',
        body: {
          userId: _this.userId,
        },
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          _this.studentList = res.resultData;
          _this.newStudentList = res.resultData[0].users;
          _this.defautlClassName.push(res.resultData[0].className);
        }
      });
    },
    getChartData() {
      // ebook/teacher/statistics/statistics
      const param = {
        bookId: this.bookId,
        type: this.type,
        classIds: this.classIds,
        studentIds: this.studentIds,
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/statistics/statistics',
        body: param,
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            const data = res.resultData;
            this.tableData = res.resultData.read.yRes;
            // 雷达图数据初始化
            const resData = res.resultData;
            const read = resData.read;
            const label = resData.label;
            const build = resData.build;
            const mutual = resData.mutual;
            this.behaviorArray = [];
            read.yRes.forEach((item, index) => {
              const obj = {};
              const name = read.yRes[index].name;
              const value = [];
              value[0] = (read.yRes[index].collectSum / 3600).toFixed(1); // 秒转小时处理
              value[1] = label.yRes[index].collectSum.toFixed(2);
              value[2] = build.yRes[index].collectSum.toFixed(2);
              value[3] = mutual.yRes[index].collectSum.toFixed(2);
              obj.name = name;
              obj.value = value;
              this.behaviorArray.push(obj);
            });
            this.columns = res.resultData.read.yRes[0].tableData;
            const series = [];
            let dataBuild = [];
            const dataStar = [];
            const dataStarSeries = [];
            switch (this.dataType) {
              case 'read':
                dataBuild = data.read.xRes;
                res.resultData.read.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data,
                  });
                  dataStar.push(item.name);
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5,
                      },
                    },
                  });
                });
                this.tableData = res.resultData.read.yRes;
                break;
              case 'build':
                dataBuild = data.build.xRes;
                res.resultData.build.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data,
                  });
                  dataStar.push(item.name);
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5,
                      },
                    },
                  });
                });
                this.tableData = res.resultData.build.yRes;
                break;
              case 'mutual':
                dataBuild = data.mutual.xRes;
                res.resultData.mutual.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data,
                  });
                  dataStar.push(item.name);
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5,
                      },
                    },
                  });
                });
                this.tableData = res.resultData.build.yRes;
                break;
              case 'label':
                dataBuild = data.label.xRes;
                res.resultData.label.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data,
                  });
                  dataStar.push(item.name);
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5,
                      },
                    },
                  });
                });
                this.tableData = res.resultData.label.yRes;
                break;
            }

            // console.log(this.tableData);
            this.tableData.forEach((o) => {
              o.tableData.forEach((p) => {
                // 被动行为 秒转小时处理
                p.count = this.dataType == 'read' ? (p.count / 3600).toFixed(1) : p.count.toFixed(2);
              });
            });
            series.forEach((o) => {
              o.data.forEach((p, idx) => {
                // 被动行为 秒转小时处理
                o.data[idx] = this.dataType == 'read' ? (p / 3600).toFixed(1) : p.toFixed(2);
              });
            });

            const chartBar = this.$echarts.init(document.getElementById('echarts_bar'));
            const optionBar = {
              color: this.color,
              dataZoom: [
                {
                  type: 'slider', // slider表示有滑动块的，inside表示内置的
                  backgroundColor: 'rgba(216,165,101,0.2)',
                  fillerColor: 'rgba(216,165,101,0.4)', // 选中范围的填充颜色。
                  borderColor: '#ddd',
                  show: true,
                  xAxisIndex: [0],
                  start: 0,
                  end: 80,
                },
              ],
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
              },
              grid: {
                left: '0%',
                right: '0%',
                bottom: '10%',
                top: '10%',
                containLabel: true,
              },
              calculable: true,
              legend: {
                data: dataStar, // 被动行为
                y: '5px', // 图例说明文字设置
                x: '0px',
              },
              xAxis: [
                {
                  type: 'category',
                  axisTick: { show: false },
                  axisLine: { show: false },
                  axisLabel: {
                    show: true,
                    interval: 0,
                    formatter: function (value) {
                      var ret = ''; // 拼接加\n返回的类目项
                      var maxLength = 4; // 每项显示文字个数
                      var valLength = value.length; // X轴类目项的文字个数
                      var rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数
                      if (rowN > 1) {
                        // 如果类目项的文字大于4,
                        for (var i = 0; i < rowN; i++) {
                          var temp = ''; // 每次截取的字符串
                          var start = i * maxLength; // 开始截取的位置
                          var end = start + maxLength; // 结束截取的位置
                          // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                          temp = value.substring(start, end) + '\n';
                          ret += temp; // 凭借最终的字符串
                        }
                        return ret;
                      } else {
                        return value;
                      }
                    },
                    textStyle: {
                      color: '#000', // X轴文字颜色
                      padding: [0, 0, 0, 0],
                      fontSize: 14,
                    },
                  },
                  data: data.read.xRes,
                },
              ],
              yAxis: [
                {
                  type: 'value',
                  axisLine: { show: false },
                  axisTick: { show: false },
                },
              ],
              series: series,
            };
            chartBar.setOption(optionBar);
            const chartStar = this.$echarts.init(document.getElementById('echarts_star'));
            const optionStar = {
              color: this.color,
              backgroundColor: '#fff',
              legend: {
                show: true,
                // icon: 'circle',//图例形状
                top: 8,
                left: 0,
                center: 20,
                itemWidth: 14, // 图例标记的图形宽度。[ default: 25 ]
                itemHeight: 14, // 图例标记的图形高度。[ default: 14 ]
                itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
                textStyle: {
                  fontSize: 14,
                  color: '#000',
                },
                data: dataStar,
              },
              grid: {
                left: '0%',
                right: '0%',
                bottom: '10%',
                top: '10%',
                containLabel: true,
              },
              tooltip: {
                show: true,
                trigger: 'item',
              },
              radar: [
                {
                  indicator: [
                    // {
                    //     text: '学习结果',
                    //     max: 100
                    // },
                    {
                      text: '被动行为',
                      min: 0,
                      axisLabel: { show: true },
                    },
                    {
                      text: '主动行为',
                      axisLabel: { show: true },
                      min: 0,
                    },
                    {
                      text: '构建行为',
                      axisLabel: { show: true },
                      min: 0,
                    },
                    {
                      text: '交互行为',
                      axisLabel: { show: true },
                      min: 0,
                    },
                  ],
                  textStyle: {
                    color: 'red',
                  },
                  center: ['50%', '50%'],
                  radius: 142,
                  startAngle: 90,
                  splitNumber: 5,
                  orient: 'horizontal', // 图例列表的布局朝向,默认'horizontal'为横向,'vertical'为纵向.
                  name: {
                    formatter: '{value}',
                    textStyle: {
                      fontSize: 14, // 外圈标签字体大小
                      color: '#000', // 外圈标签字体颜色
                    },
                  },
                  splitArea: {
                    // 坐标轴在 grid 区域中的分隔区域，默认不显示。
                    show: true,
                    areaStyle: {
                      // 分隔区域的样式设置。
                      color: ['#fff'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                    },
                  },
                  axisLabel: {
                    // 展示刻度
                    show: true,
                  },
                  axisLine: {
                    // 指向外圈文本的分隔线样式
                    lineStyle: {
                      color: '#e0e0e0',
                    },
                  },
                  splitLine: {
                    lineStyle: {
                      color: '#e0e0e0', // 分隔线颜色
                      width: 1, // 分隔线线宽
                    },
                  },
                },
              ],
              series: [
                {
                  name: '雷达图',
                  type: 'radar',
                  itemStyle: {
                    emphasis: {
                      lineStyle: {
                        width: 5,
                      },
                    },
                  },
                  data: this.behaviorArray,
                  // color: this.color
                },
              ],
            };
            chartStar.setOption(optionStar);
          }
        });
    },
    getAllData() {
      return new Promise((resolve, reject) => {
        if (true) {
          resolve(value);
        } else {
        }
      });
    },
    changeBook(item, index) {
      this.current = index;
      this.bookId = item.id;
      this.getChartData();
    },
    changeType(item, index) {
      this.currentType = index;
      this.type = item.key;
      this.showRelDiv = false;
      this.studentShow = false;
      this.studentModal = false;
      this.classShow = false;
      this.classModal = false;
      this.stuULShow = false;

      if (item.key === 1) {
        this.classShow = true;
        this.getChartData();
      } else if (item.key === 2) {
        this.stuULShow = true;
        this.studentShow = true;
        this.studentModal = true;
        this.getChartData();
      } else {
        this.showRelDiv = true;
        this.classModal = true;
      }
    },
    classChange(e) {
      this.classIds = e;
      this.getChartData();
    },
    beaviourChange(e) {
      // console.log(e)
    },
    changeBehaviour(item, index) {
      this.becurrent = index;
      this.dataType = item.key;
    },
    onSearch() {},
    lookAllStudent() {
      // 查看全部
      this.studentModal = true;
    },
    handleClassChange(e) {
      // 弹窗班级选择
      this.newStudentList = this.studentList.filter(function (item) {
        return item.id == e;
      });
      this.newStudentList = this.newStudentList[0].users;
      if (this.newStudentList == null || this.newStudentList.length < 1) {
        this.$message.warning('您的班级下面还没有学生');
      }
    },
    handleOk() {},
    handleCancel() {
      if (this.studentsCheckedList.length < 1) {
        this.classShow = true;
      } else {
        this.classShow = false;
      }
    },
    studentsChange(checkedList) {
      // 选择学生
      if (checkedList.length < 1) {
        this.classShow = true;
      } else {
        this.classShow = false;
      }
      this.studentsCheckedList = checkedList;
      this.studentIds = checkedList;
      if (checkedList.length > 5) {
        this.$message.warning('最多只能选择5个学生噢');
        return false;
      }
      this.studentIds = [];
      checkedList.map((item) => {
        this.studentIds.push(item.userId);
      });
      // this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
    },
    deterMine() {
      if (this.studentIds.length > 5) {
        this.$message.warning('最多只能选择5个学生噢');
        return false;
      } else {
        this.getChartData();
        this.studentModal = false;
      }
    },
    init(legendData, axisLabel, seriesValue) {
      const chartBar = this.$echarts.init(document.getElementById('echarts_bar'));
      const chartStar = this.$echarts.init(document.getElementById('echarts_star'));
      const optionBar = {
        color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
        dataZoom: [
          {
            type: 'slider', // slider表示有滑动块的，inside表示内置的
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 80,
          },
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '10%',
          top: '10%',
          containLabel: true,
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: {
              show: true,
              interval: 0,
              formatter: function (value) {
                var ret = ''; // 拼接加\n返回的类目项
                var maxLength = 4; // 每项显示文字个数
                var valLength = value.length; // X轴类目项的文字个数
                var rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数
                if (rowN > 1) {
                  // 如果类目项的文字大于4,
                  for (var i = 0; i < rowN; i++) {
                    var temp = ''; // 每次截取的字符串
                    var start = i * maxLength; // 开始截取的位置
                    var end = start + maxLength; // 结束截取的位置
                    // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    temp = value.substring(start, end) + '\n';
                    ret += temp; // 凭借最终的字符串
                  }
                  return ret;
                } else {
                  return value;
                }
              },
              textStyle: {
                color: '#000', // X轴文字颜色
                padding: [0, 0, 0, 0],
                fontSize: 14,
              },
            },
            data: [
              '第一单元青春的的价值',
              '第二单元青春的的价值',
              '第三单元青春的的价值',
              '第四单元青春的的价值',
              '第五单元青春的的价值',
              '第六单元青春的的价值',
              '第七单元青春的的价值',
              '第八单元青春的的价值',
              '第九单元青春的的价值',
              '第十单元青春的的价值',
            ],
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: { show: false },
            axisTick: { show: false },
          },
        ],
        series: [],
      };
      chartBar.setOption(optionBar);
      const optionStar = {
        color: ['#FF5F4C', '#32C1FF', '#FFD300'],
        backgroundColor: '#fff',
        legend: {
          show: true,
          // icon: 'circle',//图例形状
          top: 45,
          left: 0,
          center: 20,
          itemWidth: 14, // 图例标记的图形宽度。[ default: 25 ]
          itemHeight: 14, // 图例标记的图形高度。[ default: 14 ]
          itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          textStyle: {
            fontSize: 14,
            color: '#000',
          },
        },
        radar: [
          {
            indicator: [
              {
                text: '学习结果',
                max: 100,
              },
              {
                text: '被动行为',
                max: 100,
              },
              {
                text: '主动行为',
                max: 100,
              },
              {
                text: '构建行为',
                max: 100,
              },
              {
                text: '交互行为',
                max: 100,
              },
            ],
            textStyle: {
              color: 'red',
            },
            center: ['50%', '50%'],
            radius: 142,
            startAngle: 90,
            splitNumber: 5,
            orient: 'horizontal', // 图例列表的布局朝向,默认'horizontal'为横向,'vertical'为纵向.
            name: {
              formatter: '{value}',
              textStyle: {
                fontSize: 14, // 外圈标签字体大小
                color: '#000', // 外圈标签字体颜色
              },
            },
            splitArea: {
              // 坐标轴在 grid 区域中的分隔区域，默认不显示。
              show: true,
              areaStyle: {
                // 分隔区域的样式设置。
                color: ['#f6f6f6'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              },
            },
            axisLabel: {
              // 展示刻度
              show: true,
            },
            axisLine: {
              // 指向外圈文本的分隔线样式
              lineStyle: {
                color: '#e0e0e0',
              },
            },
            splitLine: {
              lineStyle: {
                color: '#e0e0e0', // 分隔线颜色
                width: 1, // 分隔线线宽
              },
            },
          },
        ],
        series: [
          {
            name: '雷达图',
            type: 'radar',
            itemStyle: {
              emphasis: {
                lineStyle: {
                  width: 2,
                },
              },
            },
            data: [],
          },
        ],
      };
      chartStar.setOption(optionStar);
    },
    logininit() {
      // const parameter = decryptDes('5ecfd021795f9a10245329b509849e106cc9d2d77acd05ad4a6c3c1761d3d48e3b226ed0bd4f3a0d8912aeef0ae53a44b7ea35859aff038bdd69909edc94c9029d1c189272ce8bf0')
      if (this.$route.path.indexOf('/accompanyStudy') === 0) {
        this.isPad = false;
        this.userId = this.$getUserInfo().id;
        this.access_token = localStorage.getItem('access_token');
      } else {
        const parameter = decryptDes(this.$route.params.parameter);
        // console.log(this.$route.params.parameter);
        // console.log(parameter);
        const params = parameter.split('&');
        this.access_token = params[0];
        this.userId = params[1];
      }
    },

    selectClass(item) {
      this.classModal = false;
      this.relClassId = item.id;

      const param = {
        bookId: this.bookId,
        classId: item.id,
        access_token: this.access_token,
        userId: this.userId,
      };

      const url = this.$baseUrl + 'ebook/teacher/statistics/classRelations';
      // this.$fetch({
      //   url: this.$baseUrl + 'ebook/teacher/statistics/classRelations',
      //   body: param,
      // }).done
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.resultData) {
            const nodes = res.data.resultData.nodes;
            const links = res.data.resultData.links;
            const myChart = this.$echarts.init(document.getElementById('echarts_rel'));
            if (!nodes || !links) {
              myChart.dispose();
              return;
            }

            nodes.forEach(function (node) {
              node.symbolSize = 25;
              node.itemStyle = {
                color: '#d1b488',
              };
            });
            const option = {
              title: {
                text: item.className,
                top: 'top',
                left: 'left',
              },
              tooltip: {
                trigger: 'item',
                textStyle: { fontSize: '100%' },
                formatter: (params) => {
                  // console.log(params);
                  if (params.dataType === 'edge') {
                    const sn = nodes.find((o) => o.id === params.data.source);
                    const tn = nodes.find((o) => o.id === params.data.target);
                    return `<div>${sn.name}　<b>${params.value}</b>　${tn.name}</div>`;
                  }
                },
              },
              series: [
                {
                  type: 'graph',
                  layout: 'force',
                  data: nodes,
                  links: links,
                  // categories: graph.categories,
                  roam: true,

                  label: {
                    position: 'right',
                    color: 'black',
                    fontSize: 18,
                  },
                  force: {
                    edgeLength: [100, 150],
                    repulsion: 200,
                    gravity: 0.2,
                  },
                },
              ],
            };
            myChart.setOption(option);
          }
        })
        .catch((res) => {
          this.$message.error(JSON.stringify(res));
        });
    },

    exportBehavior() {
      const param = {
        access_token: this.access_token,
        bookId: this.bookId,
        type: this.type,
        classIds: this.classIds,
        studentIds: this.studentIds,
      };
      this.downBtnLoading = true;

      const ptype = this.type;
      const url = this.$httpConfig.exportBehaviorExcel;
      axios
        .post(url, param)
        .then((res) => {
          // console.log(res);
          if (!res.data || !res.data.resultData) {
            this.$message.info('无可导出数据');
            return;
          }

          const url1 =
            this.$baseUrl + 'ebook/teacher/statistics/downloadFile?fileName=' + encodeURI(res.data.resultData) + '&access_token=' + this.access_token
          // this.$message.error('开始下载');
          // const link = document.createElement('a');
          // const blob = new Blob([res.data], {
          //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          // });
          // link.style.display = 'none';
          // link.href = URL.createObjectURL(blob);
          // link.download =
          //   (this.type == '1' ? '班级' : '学生') + '行为明细' + format.formatDayTime(new Date().valueOf()) + '.xlsx';
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);

          if (this.isPad) {
            // APP端做拦截处理
            if (
              window.webkit &&
              window.webkit.messageHandlers &&
              window.webkit.messageHandlers.readBlob &&
              window.webkit.messageHandlers.readBlob.postMessage
            ) {
              window.webkit.messageHandlers.readBlob.postMessage({ url: url1, name: res.data.resultData });
            }
            if (window.PosObj && window.PosObj.invokeFun) {
              window.PosObj.invokeFun('readBlob', { url: url1, name: res.data.resultData });
            }
            // const h = this.$createElement;
            // this.$info({
            //   title: '点击确认按钮复制链接后，请至浏览器下载',
            //   content: h('div', {}, []),
            //   onOk() {
            //     const input = document.createElement('input');
            //     document.body.appendChild(input);
            //     input.value = url1;
            //     input.select();
            //     document.execCommand('copy');
            //     input.remove();
            //   },
            // });
          } else {
            const x = new XMLHttpRequest();
            x.open('GET', url1, true);
            x.responseType = 'blob';
            x.onload = function (e) {
              var url2 = window.URL.createObjectURL(x.response);
              var a = document.createElement('a');
              a.href = url2;
              a.download =
                (ptype == '1' ? '【班级表现】' : '【学生表现】') +
                ' ICAP统计结果' +
                format.formatDayTime(new Date().valueOf()) +
                '.xlsx';
              a.click();
            };
            x.send();
          }
        })
        .catch(() => {
          this.$message.error('发生错误');
        })
        .finally((res) => {
          //   this.$message.error('下载完成');
          this.downBtnLoading = false;
        });
    },

    exportRelation(e) {
      const param = {
        access_token: this.access_token,
        bookId: this.bookId,
        classId: this.relClassId,
        userId: this.userId,
      };
      this.downBtnLoading = true;

      const url = this.$httpConfig.exportRelationExcel;
      axios
        .post(url, param)
        .then((res) => {
          if (!res.data || !res.data.resultData) {
            this.$message.info('无可导出数据');
            return;
          }

          const url1 =
            this.$baseUrl + 'ebook/teacher/statistics/downloadFile?fileName=' + encodeURI(res.data.resultData)+ '&access_token=' + this.access_token
          // console.log(res);
          // 移动端blob不支持
          // const blob = new Blob([res.data], {
          //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          // });
          // const link = document.createElement('a');
          // // const URL = window.URL || window.webkitURL;
          // // link.href = URL.createObjectURL(blob);
          // this.$message.error('开始1');
          // link.href = url1;
          // link.style.display = 'none';
          // link.target = '_blank';
          // link.download = '交互关系' + format.formatDayTime(new Date().valueOf()) + '.xlsx';
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);

          if (this.isPad) {
            // APP端做拦截处理
            if (
              window.webkit &&
              window.webkit.messageHandlers &&
              window.webkit.messageHandlers.readBlob &&
              window.webkit.messageHandlers.readBlob.postMessage
            ) {
              window.webkit.messageHandlers.readBlob.postMessage({ url: url1, name: res.data.resultData });
            }
            if (window.PosObj && window.PosObj.invokeFun) {
              window.PosObj.invokeFun('readBlob', { url: url1, name: res.data.resultData });
            }
            // const h = this.$createElement;
            // this.$info({
            //   title: '点击确认按钮复制链接后，请至浏览器下载',
            //   content: h('div', {}, []),
            //   onOk() {
            //     const input = document.createElement('input');
            //     document.body.appendChild(input);
            //     input.value = url1;
            //     input.select();
            //     document.execCommand('copy');
            //     input.remove();
            //   },
            // });
          } else {
            const x = new XMLHttpRequest();
            x.open('GET', url1, true);
            x.responseType = 'blob';
            x.onload = function (e) {
              var url2 = window.URL.createObjectURL(x.response);
              var a = document.createElement('a');
              a.href = url2;
              a.download = '【学生交互关系】ICAP统计结果' + format.formatDayTime(new Date().valueOf()) + '.xlsx';
              a.click();
            };
            x.send();
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error('发生错误');
        })
        .finally(() => (this.downBtnLoading = false));
    },
  },
};
</script>
<style lang="less" scoped>
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
.topGo {
  height: 110px;
  background-color: #fff;
  position: relative;
  padding: 0 50px;
  .goHistory {
    width: 16px;
    height: 32px;
    cursor: pointer;
  }
  .icon {
    position: absolute;
    top: 50%;
    margin-top: -7px;
    left: 50px;
  }
  .iconText {
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: 100px;
    color: #9d9292;
    font-size: 24px;
  }
}
.main {
  width: 1200px;
  //min-height: 900px;
  background: #fff;
  margin: 20px auto;
  padding: 20px 20px;
  border-radius: 12px;
  // 主要内容
  .content {
    .behaviourLoad {
      // margin-top: 20px;
      height: 50px;
      line-height: 50px;
      text-align: left;
      font-size: 18px;
      font-weight: 600;
      .xingwei {
        width: 24px;
        height: 24px;
        margin-top: -4px;
      }
    }
    .behaviourLoadUl {
      display: flex;
      margin-top: 10px;
      .beLi {
        width: 90px;
        height: 24px;
        line-height: 24px;
        background: #f6f6f6;
        font-size: 16px;
        color: #000;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;
        border-radius: 12px;
      }
    }
    .echarts_bar {
      margin-top: 20px;
      max-width: 1200px;
      min-height: 500px;
    }
    .table {
      // width:1200px;
      margin: 0 auto;
      // min-height: 300px;
      overflow-x: scroll;
      // background: #F8F8F8;
      .tabUl {
        width: 1200px;
        display: flex;
        height: 40px;
        line-height: 40px;
        background: #f8f8f8;
        border-radius: 12px;
        // min-width: 100px;
        margin-top: 10px;
        .tabLi {
          width: 120px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.pad_main {
  width: 690px;
  //min-height: 900px;
  background: #fff;
  margin: 0 15px;
  padding: 20px;
  border-radius: 12px;
  // 主要内容
  .content {
    .behaviourLoad {
      // margin-top: 20px;
      height: 50px;
      line-height: 50px;
      text-align: left;
      font-size: 18px;
      font-weight: 600;
      .xingwei {
        width: 24px;
        height: 24px;
        margin-top: -4px;
      }
    }
    .behaviourLoadUl {
      display: flex;
      margin-top: 10px;
      .beLi {
        width: 90px;
        height: 24px;
        line-height: 24px;
        background: #f6f6f6;
        font-size: 16px;
        color: #000;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;
        border-radius: 12px;
      }
    }
    .is_pad_echarts_bar {
      margin-top: 20px;
      max-width: 660px;
      min-height: 500px;
    }
    .table {
      // width:700px;
      margin: 0 auto;
      // min-height: 300px;
      overflow-x: scroll;
      // background: #F8F8F8;
      .tabUl {
        width: 1200px;
        display: flex;
        height: 40px;
        line-height: 40px;
        background: #f8f8f8;
        border-radius: 12px;
        // min-width: 100px;
        margin-top: 10px;
        .tabLi {
          width: 120px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.main2 {
  width: 1200px;
  // height: 400px;
  background: #fff;
  margin: 0 auto;
  padding: 20px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  // 主要内容
  .echarts_star {
    max-width: 1200px;
    min-height: 500px;
  }
  .is_pad_echarts_star {
    width: 560px;
    height: 400px;
  }

  .echarts_rel {
    max-width: 1200px;
    min-height: 650px;
  }

  .behaviourLoad {
    // margin-top: 20px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    .xingwei {
      width: 24px;
      height: 24px;
      margin-top: -4px;
    }
  }
}
.pad_main2 {
  width: 690px;
  // height: 400px;
  background: #fff;
  margin: 20px 15px 15px;
  padding: 20px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  // 主要内容
  .is_pad_echarts_star {
    width: 660px;
    height: 500px;
  }

  .is_pad_echarts_rel {
    width: 560px;
    height: 400px;
  }

  .behaviourLoad {
    // margin-top: 20px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    .xingwei {
      width: 24px;
      height: 24px;
      margin-top: -4px;
    }
  }
}
.type {
  display: flex;
  .classType {
    height: 40px;
    line-height: 40px;
    display: flex;
    margin-top: 20px;
    flex: 1;
    .classLi {
      // width: 130px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fff;
      color: @primary-color;
      border: 1px solid @primary-color;
      border-radius: 5px;
      margin-right: 20px;
      padding: 0 20px;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .search {
    margin-top: 10px;
    line-height: 40px;
  }
}
.bookSelect {
  height: 40px;
  line-height: 40px;
  display: flex;
  margin-top: 30px;
  .titleLi {
    text-align: left;
    cursor: pointer;
    font-size: 18px;
    margin-right: 10px;
  }
}
.clssUl {
  margin-top: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #000;
  .lookAll {
    display: inline-block;
    width: 130px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    float: right;
    color: @primary-color;
    font-size: 16px;
    cursor: pointer;
  }
}
.stuUl {
  margin-top: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #000;
  .stuLi {
    height: 30px;
    line-height: 30px;
    width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.classbehaviour {
  margin-top: 20px;
}
.activeLi {
  cursor: pointer;
  color: #000;
  font-size: 20px;
  display: inline-block;
  text-align: left;
  position: relative;
  margin-right: 10px;
  cursor: pointer;
  &::after {
    width: 50px;
    height: 4px;
    content: '';
    position: absolute;
    top: 90%;
    left: 50%;
    margin-left: -25px;
    background-color: @primary-color;
  }
}
.activeClass {
  cursor: pointer;
  background: @primary-color;
  color: #fff;
  font-size: 16px;
  display: inline-block;
  // width: 130px;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  margin-right: 20px;
  padding: 0 20px;
  cursor: pointer;
}
.beactiveLi {
  background: @primary-color;
  color: #fff;
  width: 90px;
  margin-right: 20px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  border-radius: 12px;
}
//弹窗样式
.students {
  .classSelect {
  }
  .studentsList {
    display: flex;
    margin-top: 10px;
    min-height: 300px;
    border-bottom: 1px solid #ececec;
    .col {
      height: 36px;
      line-height: 36px;
    }
  }
  .bot {
    .checkstu {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 24px;
      margin-top: 10px;
      margin-bottom: 8px;
      .hasCheck {
        color: #999999;
      }
      .stuDe {
        color: #000000;
        margin-left: 10px;
        margin-top: 10px;
      }
    }
    .surebtn {
      text-align: center;
      height: 50px;
      width: 100%;
      .determine {
        width: 170px;
        height: 32px;
        background: @primary-color;
        box-shadow: 0px 2px 10px 0px #f5e6d4;
        border-radius: 2px;
        color: #fff;
        font-size: 14px;
      }
      .tt {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        margin-top: 10px;
        transform: scale(0.9);
      }
    }
  }
}
.pad_table {
  width: 620px;
  // margin:0 auto;
  // min-height: 300px;
  overflow-x: scroll;
  // background: #F8F8F8;
  .tabUl {
    width: 1200px;
    display: flex;
    height: 40px;
    line-height: 40px;
    background: #f8f8f8;
    border-radius: 12px;
    // min-width: 100px;
    margin-top: 10px;
    .tabLi {
      width: 120px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.is_pad {
  padding: 0px 20px;
  width: 660px;
  margin: 0 20px;
}
.no_pad {
  width: 1200px;
  margin: 0 auto;
}
.is_pad_echarts_bar {
  width: 560px;
  height: 500px;
}
/deep/.ant-checkbox-wrapper {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}
/deep/.ant-checkbox-wrapper {
  font-size: 16px;
  color: #000;
}
::-webkit-scrollbar-track-piece {
  //滚动条凹槽的颜色，还可以设置边框属性
  background-color: #f8f8f8;
}
::-webkit-scrollbar {
  //滚动条的宽度
  width: 9px;
  height: 9px;
}
::-webkit-scrollbar-thumb {
  //滚动条的设置
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
</style>
